<template>
  <section class="fluent">
    <banner part-id="fluent" />
    <div
      class="section-text-background flowing-text-background"
      :style="backgroundTextStyle"
      :class="lang === 'zh' ? 'flowing-text-background-zh' : ''"
    >
      {{ lang === 'zh' ? '畅快体验' : 'FLOWING' }}
    </div>
    <quantum />
    <anti-carton v-if="lang === 'zh'" />
    <anti-carton-foreign v-if="lang !== 'zh'" />
    <SuperTouch />
    <freeTimeForeign />
    <cloud-infor v-if="lang !== 'zh'" />
    <Codebook v-if="lang !== 'zh'" />
    <PrivacyProtectionOversea v-if="lang !== 'zh'" />
  </section>
</template>

<script>
import Banner from '../Banner/PartBanner';
// import FastStart from './FastStart';
import Quantum from './Quantum';
import FreeTimeForeign from './FreeTimeForeign';
import AntiCarton from './AntiCarton';
import AntiCartonForeign from './AntiCartonForeign';
import SuperTouch from './SuperTouch';
import CloudInfor from '../Privacy/CloudInfor';
import PrivacyProtectionOversea from '../Privacy/PrivacyProtectionOversea';
import Codebook from '../Privacy/Codebook';

import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

const phaseOffsetList = [-480 / 960, 480 / 960, 49 / 960, 0, 0, 0, 96 / 960, -240 / 960, 0];
const phasePreSumList = [];
let progressList = [100, 50, 100, 50, 150, 130, 100, 50, 150 + 50 + (450 + 100) + 300];
let progressSum = progressList.reduce((a, b) => (b += a));
const progressBreakPoint = [];
for (let i = 0; i < progressList.length; i++) {
  progressBreakPoint[i] = (progressBreakPoint[i - 1] || 0) + progressList[i] / progressSum;
  phasePreSumList.push((phasePreSumList[i - 1] || 0) + (phaseOffsetList[i - 1] || 0));
}

export default {
  inject: ['lang'],
  components: {
    Banner,
    // // FastStart,
    // FreeTime,
    Quantum,
    FreeTimeForeign,
    AntiCarton,
    AntiCartonForeign,
    SuperTouch,
    CloudInfor,
    Codebook,
    PrivacyProtectionOversea
  },
  mixins: [UpdateAnimationMixin],
  data() {
    if (this.lang === 'zh') {
      progressList = [100, 50, 100, 50, 150, 100, 100, 50, 250];
      if (window.innerHeight > 1000) {
        // 适配大屏幕 2560*1340
        const scaleRate = (window.innerHeight - 960) / 960;
        progressList[6] = 100 - scaleRate * 50;
        progressList[8] = 250 - scaleRate * 50;
      }

      progressSum = progressList.reduce((a, b) => (b += a));
      progressBreakPoint.length = 0;
      for (let i = 0; i < progressList.length; i++) {
        progressBreakPoint[i] = (progressBreakPoint[i - 1] || 0) + progressList[i] / progressSum;
        phasePreSumList.push((phasePreSumList[i - 1] || 0) + (phaseOffsetList[i - 1] || 0));
      }
    }
    return {
      backgroundTextProgress: 0,
      backgroundTextMobileProgress: 0
    };
  },
  computed: {
    backgroundTextStyle() {
      const progress = this.backgroundTextProgress;
      const innerHeight = window.innerHeight;

      if (location.href.indexOf('localhost:800') > -1 || (this.lang === 'zh' && window.innerWidth <= 734)) {
        return null;
      }
      if (window.innerWidth <= 734) {
        if (this.sceneOverseaMobile && this.backgroundTextMobileProgress > 0) {
          let colorChange = Math.floor(229 * this.backgroundTextMobileProgress);
          return {
            color: `rgb(${249 - colorChange}, ${250 - colorChange}, ${250 - colorChange})`
          };
        }
        return null;
      }

      const currentPhase = progressBreakPoint.indexOf(
        progressBreakPoint.find(item => progress <= item) || progressBreakPoint[progressBreakPoint.length - 1]
      );
      let transY = 0;
      let colorChange = 0;
      let opacity = 1;
      // 位移
      if (currentPhase === 0) {
        transY = (progress / progressBreakPoint[0]) * phaseOffsetList[0] * innerHeight;
      } else {
        transY =
          ((progress - progressBreakPoint[currentPhase - 1]) /
            (progressBreakPoint[currentPhase] - progressBreakPoint[currentPhase - 1])) *
            phaseOffsetList[currentPhase] *
            innerHeight +
          phasePreSumList[currentPhase] * innerHeight;
      }
      // 颜色
      const startChange =
        this.lang === 'zh' ? 530 - 70 * (window.innerHeight > 960 ? (window.innerHeight - 960) / 960 : 0) : 580;
      if (progress < startChange / progressSum) {
        colorChange = 0;
      } else if (progress >= startChange / progressSum && progress < (startChange + 50) / progressSum) {
        // colorChange = Math.floor((229 * (progress - startChange / progressSum)) / (50 / progressSum));
        colorChange = 0;
      } else if (
        progress >= (progressSum - 100 - 350) / progressSum &&
        progress <= (progressSum - 75 - 350) / progressSum
      ) {
        colorChange =
          229 - Math.floor((229 * (progress - (progressSum - 100 - 350) / progressSum)) / (25 / progressSum));
      } else if (progress > (progressSum - 75 - 350) / progressSum && this.lang !== 'zh') {
        colorChange = 0;
      } else {
        colorChange = 229;
      }
      // 透明度
      if (progress < startChange / progressSum) {
        opacity = 1;
      } else if (progress <= (startChange + 25) / progressSum) {
        // opacity = 1 - (progress - startChange / progressSum) / (25 / progressSum);
        opacity = 0;
      } else if (progress <= (startChange + 90) / progressSum) {
        // 75
        // opacity = (progress - (startChange + 25) / progressSum) / (50 / progressSum);
        opacity = 0;
      } else if (progress <= (progressSum - 107 - 350) / progressSum) {
        opacity = 1;
        // 下面是充电部分
      } else if (progress <= (progressSum - 85 - 350) / progressSum) {
        // opacity = 1 - (progress - (progressSum - 100 - 350) / progressSum) / (25 / progressSum);
        opacity = 0;
      } else if (progress <= (progressSum - 50 - 350) / progressSum) {
        // opacity = (progress - (progressSum - 75 - 350) / progressSum) / (25 / progressSum);
        if (progress <= (progressSum - 50 - 350) / progressSum) {
          opacity = 0;
        } else {
          opacity = (progress - (progressSum - 75 - 350) / progressSum) / (25 / progressSum);
        }
      } else {
        opacity = 1;
      }

      return {
        opacity,
        transform: `translate3d(0,${transY}px,0) !important`,
        color: `rgb(${249 - colorChange}, ${250 - colorChange}, ${250 - colorChange})`
      };
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      let fluentHeight = document.querySelector('.fluent').clientHeight;
      setTimeout(() => {
        let fluentHeight = document.querySelector('.fluent').clientHeight - 2 * window.innerHeight + 200;
        this.scene.duration(fluentHeight);
        // this.scene.duration(window.innerWidth <= 737 ? fluentHeight : (progressSum / 100) * window.innerHeight);
      }, 300);
      this.scene = new ScrollMagic.Scene({
        // duration: window.innerWidth <= 737 ? fluentHeight : (progressSum / 100) * window.innerHeight,
        duration: fluentHeight,
        triggerElement: '.fluent',
        offset: window.innerHeight,
        triggerHook: 0
      })
        .setPin('.flowing-text-background')
        .addTo(Controller)
        .on('progress', e => {
          // this.backgroundTextProgress = e.progress;
          if (Math.abs(this.progress - e.progress) > 0.3 || e.progress <= (progressSum - 107 - 350) / progressSum) {
            this.backgroundTextProgress = e.progress;
          } else {
            this.updateBezier('backgroundTextProgress', e.progress, 100);
          }
        });
    },
    initScrollOverseaMobile() {
      const offset = document.querySelector('.saving-mobile-text-intro').clientHeight - 32;
      this.sceneOverseaMobile = new ScrollMagic.Scene({
        duration: 0.5 * window.innerHeight,
        triggerElement: '.free-Time-saving-mobile',
        triggerHook: 0,
        offset: offset
      })
        .addTo(Controller)
        .on('progress', e => {
          this.backgroundTextMobileProgress = e.progress;
        });
    },
    resizeHandler() {
      if (location.href.indexOf('localhost:800') > -1) return;
      if (!this.scene) {
        this.initScroll();
      } else {
        let fluentHeight = document.querySelector('.fluent').clientHeight - 2 * window.innerHeight + 200;
        this.scene.offset(window.innerHeight).duration(fluentHeight);
        // .duration(window.innerWidth <= 737 ? fluentHeight : (progressSum / 100) * window.innerHeight);
      }

      if (window.innerWidth <= 734 && this.lang !== 'zh') {
        if (!this.sceneOverseaMobile) {
          this.initScrollOverseaMobile();
        } else {
          this.sceneOverseaMobile
            .duration(0.5 * window.innerHeight)
            .offset(document.querySelector('.saving-mobile-text-intro').clientHeight - 32);
        }
      } else {
        if (this.sceneOverseaMobile) {
          this.sceneOverseaMobile.destroy(true);
          this.sceneOverseaMobile = null;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './fluent.scss';
@import '../Privacy/privacy.scss';
</style>
